import { useState, useMemo, createContext } from 'react';
import Api from '../../api/api';

const AppContext = createContext();
AppContext.displayName = 'AppContext';

export default function AppCtxComponent(children) {
  const [blockEditor, dispatchBlockEditor] = useState({
    shown: false,
    compId: undefined,
    elementId: undefined
  });
  const setBlockEditor = obj => {
    dispatchBlockEditor(prevState => ({ ...prevState, ...obj }));
  };
  const showEditor = () => {
    setBlockEditor({ shown: true });
  };
  const hideEditor = () => {
    setBlockEditor({ shown: false });
  };
  const isEmbeded = () => Api.isEmbeded();

  const [isLoading, setIsLoading] = useState(false);

  const contextValue = useMemo(
    () => ({ isLoading, setIsLoading, blockEditor, setBlockEditor, showEditor, hideEditor, isEmbeded }),
    [isLoading, blockEditor]
  );

  return <AppContext.Provider value={contextValue}>{children}</AppContext.Provider>;
}

AppCtxComponent.context = AppContext;
